module.exports = __webpack_public_path__ + "images/sponsored-17065db1.svg";